/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Register_BtnInputs */



/**
* | output |
* | --- |
* | "Register" |
*
* @param {Tournament_Register_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_register_btn = /** @type {((inputs?: Tournament_Register_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Register_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("S'inscrire")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inscribirse")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Inscrever-se")
	if (locale === "it") return /** @type {LocalizedString} */ ("Iscriviti")
	return /** @type {LocalizedString} */ ("Register")
});